import { MarginType } from 'common/types/styleTypes'
import React, { ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ReadOnlyEntityUi from './ui/ReadOnlyEntityUi'
import { pageSelectors, usePage } from 'client/store/index'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
type ReadOnlyEntityProps = {
  margin?: Partial<MarginType>
  mobileMargin?: Partial<MarginType>
  children: ReactNode
  styles?: Record<string, string>
  showInDesktopMode?: boolean
  showInMobileMode?: boolean
  flex?: boolean
  flexColumn?: boolean
}

function ReadOnlyEntity({
  children,
  margin,
  mobileMargin,
  styles,
  showInMobileMode = true,
  showInDesktopMode = true,
  flex,
  flexColumn,
}: ReadOnlyEntityProps) {
  const [titleVisible, setTitleVisible] = useState(false)
  const { t } = useTranslation()
  const pageType = usePage(pageSelectors.getPageType)
  const isWebsiteLoginPage = pageType === PageTypeEnum.WebsiteLogin
  function unHover(e: React.SyntheticEvent) {
    e.stopPropagation()
    setTitleVisible(false)
  }

  function hover(e: React.SyntheticEvent) {
    e.stopPropagation()
    setTitleVisible(true)
  }
  const title = isWebsiteLoginPage
    ? t('components.core.read_only_content.title')
    : t('components.core.read_only_entity.title')

  return (
    <ReadOnlyEntityUi
      margin={margin}
      mobileMargin={mobileMargin}
      styles={styles}
      showInMobileMode={showInMobileMode}
      showInDesktopMode={showInDesktopMode}
      onMouseOver={hover}
      onMouseOut={unHover}
      title={titleVisible ? title : ''}
      flex={flex}
      flexColumn={flexColumn}
    >
      {children}
    </ReadOnlyEntityUi>
  )
}

export default ReadOnlyEntity
